module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/funabashi_ekimae_store-a921ab0966ac50016c6337cd01436993.jpg";